export default __webpack_public_path__ + "inside_fabric.png";